import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip } from '@sm/wds-react';
import { IconInfo } from '@sm/wds-icons';

const ComparisonTableFeatureRow = ({ children, title, a11yHeaders, a11yId, tooltip = null, className = '' }) => (
  <tr className={classnames('sm-comparison-table__feature', className)} data-testid="ComparisonTableFeatureRow">
    <th
      className="sm-comparison-table__feature-title wds-type--left wds-type--body"
      scope="row"
      data-testid="ComparisonTableFeatureRow__Title"
      id={a11yId}
      headers={a11yHeaders.join(' ')}
    >
      {title}
      {tooltip && (
        <Tooltip text={tooltip} placement="top" data-testid="ComparisonTableFeatureRow__Tooltip">
          <span className="wds-p-l-2">
            <IconInfo size="sm" />
          </span>
        </Tooltip>
      )}
    </th>
    {children}
  </tr>
);

ComparisonTableFeatureRow.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  a11yHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,
  a11yId: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  className: PropTypes.string,
};

ComparisonTableFeatureRow.defaultProps = {
  tooltip: null,
  className: '',
};

export default ComparisonTableFeatureRow;
